<template>
    
        <edit-form
            :title="title"
            :subTitle="subTitle"
            :schema="schema"
            storeNamespace="clients"
            objectNamespace="O_batch"
            :objectId="id"
            :listOnSave="listOnSave"
        >
        </edit-form>
    
</template>

<script>
import EditForm from '@/components/form/EditForm'
import {mapMutations} from 'vuex'

export default {
    name: "ClientEnvelopeForm",
    components: {
        EditForm,
    },
    props: {
        id: {
            type: String
        },
        listOnSave: {
            type: Boolean,
            default: false 
        },
    },
    computed: {
       schema() {
            const filter = {
                numbers: '{ type:"select", rules:"required|numeric|min_value^:1", items:["24", "48", "72", "96", "120", "144"] }',
                comment: '{ type:"input", rules:"required" }',
            }
            
            return this.$helpers.schemaParser(filter)
        },
        title() {
            return this.id ? "Update outer bag" : "Nytt emballage";
        },
        subTitle() {
            return this.id ? "Here you can edit a batch of outer bags" : "Här kan du skapa en ny batch av emaballagepåsasr";
        },
    },
    methods: {
        ...mapMutations("clients", ['SET_O_BATCH'])
    },
    mounted() {
        
        if(!this.id) {
            this.SET_O_BATCH({numbers:1})
        }
        
        
    }
}
</script>

<style>

</style>